import { CustomCheckbox } from 'components/custom-checkbox/custom-checkbox.styles';
import styled from 'styled-components';

export const MultiSelectCheckbox = styled(CustomCheckbox)`
  padding: 2px 5px;
  margin: 0;
`;
